import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';

const state = {
    session: '',
    session_details: '',
    user: '',
    authorized_user: {},
    path_intention: '',
    cancel_purchase: '',
    meta:[]
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
